import OfferService from '../../../../core/services/offer.service'
import { saveOfferDocumentId } from '../../../../core/services/storage.service'
import { LifecyclePresenter } from '../../../_components/ConnectComponent'
import { AdobeEventManager } from '../../../_utils/adobeAnalytics'
import { dataLayer } from '../../../_utils/adobeAnalytics/adobeAnalytics.conf'
import { mountDownablePDF } from '../../../_utils/pdfs/pdf'
import { PolicyTableRaw, View } from './PolicyTable.view'

export class PolicyTablePresenter implements LifecyclePresenter<View> {
  private view!: PolicyTableRaw

  initialize(view) {
    this.view = view
  }

  onLifecycleStart = async () => {
    try {
      const offerList = await OfferService.getPoliciesList()

      this.view.setInitialValues(offerList.policies, offerList.pagination)
      dataLayer.page.category.applicationStep = 'portal'
      dataLayer.page.category.pageCategory = 'Portal'
    } catch (error) {
      console.log(error)
    }
  }

  onDownloadOfferPDF = async (offerId: string, offerNumber: number) => {
    this.view.showLoading()

    try {
      let pdf = await OfferService.getOfferPDF(offerId)
      mountDownablePDF(pdf, offerNumber, true)

      AdobeEventManager.emit('portal_download_policy_pdf', 'file_downloads')

      this.view.hideLoading()
    } catch (error) {
      console.log(error)

      this.view.hideLoading()
      alert('It is NOT available to get PDF for your query')
    }
  }

  onSendOfferToCustomer = async (offerId: string) => {
    await OfferService.sendOfferByEmail(offerId)

    AdobeEventManager.emit(
      'agent/broker_send_policy_by_email_to_customer',
      'direct_contact_to_agent',
    )
    this.view.showModal()
  }

  getPolicies = async (page: number, pageSize: number) => {
    const offerList = await OfferService.getPoliciesList(page, pageSize)
    return offerList
  }

  goToViewOffer = async (offerId: string) => {
    const offer = await OfferService.getOfferDocument(offerId)
    saveOfferDocumentId(offer.id.toString())
    this.view.props.history.push('/contract/policy-summary')
  }
}
